import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EventDetailPage } from 'src/app/pages/global/event-detail/event-detail.page';
import { EventsAdminDetailPage } from '../events-admin-detail/events-admin-detail.page';

const routes: Routes = [
  {
    path: '',
    component: EventDetailPage,
  },
  {
    path: 'admin',
    component: EventsAdminDetailPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EventDetailPageRoutingModule {
}
